import type { ChatErrorType } from "@/components/chat/ChatError";

/**
 * Helper function to determine error type from error message
 */
export function getErrorType(error: string): ChatErrorType {
  const lowerError = error.toLowerCase();

  if (
    lowerError.includes("not found") ||
    lowerError.includes("assistant not found")
  ) {
    return "assistant_not_found";
  }

  if (
    lowerError.includes("not public") ||
    lowerError.includes("not available for public")
  ) {
    return "assistant_not_public";
  }

  if (
    lowerError.includes("server error") ||
    lowerError.includes("internal server")
  ) {
    return "server_error";
  }

  if (
    lowerError.includes("connection") ||
    lowerError.includes("connect") ||
    lowerError.includes("network")
  ) {
    return "connection_failed";
  }

  return "unknown";
}
